import { useContext } from 'react';

import { WhiteboardSessionContext } from '../context/WhiteboardSessionContext';

export const useWhiteboardTitle = () => {
    const { whiteboardSessionState } = useContext(WhiteboardSessionContext);

    const { currentPage, session } = whiteboardSessionState;
    if (!currentPage || !session) {
        return '';
    }

    return session.name;
};
